<template>
	<div id="novel_list">
		<div class="novel_list">
			<div class="flex-row">
				<div class="novel_list1 cursor_1" @click="goBack">
					<img src="@/assets/image/icon_right.png" alt="">
					灵感记录
				</div>
				<!-- <div class="t-m-l-20">
                    <el-button type="text" class="novel_list2 " v-if="novelList.length > 0">
                        <span @click="openEditor" v-if="isEdit">管理</span>
                        <span @click="openEditor" v-if="!isEdit">取消</span>
                    </el-button>
                </div> -->
				<div class="tops">
					{{ title }}
				</div>

			</div>
			<div class="flex-row" :class="!isEdit ? 'noEditor_pointer' : ''">
				<!-- <el-radio-group v-model="status" class="t-m-r-20" style="display: flex;user-select: none;"
					@input="statusChang">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="0">连载</el-radio-button>
					<el-radio-button label="1">完结</el-radio-button>
				</el-radio-group>
				<el-radio-group v-model="length" class="t-m-r-20" style="display: flex;user-select: none;"
					@input="lengthChang">
					<el-radio-button label="长篇">长篇</el-radio-button>
					<el-radio-button label="中篇">中篇</el-radio-button>
					<el-radio-button label="短篇">短篇</el-radio-button>
				</el-radio-group> -->
				<!-- <el-input placeholder="请输入作品名称" v-model="query" class="novel_input-with-select t-m-l-15 t-m-r-20"
					@keyup.enter.native="selectClick">
					<i class="el-icon-search el-input__icon cursor_1" :style="{ pointerEvents: !isEdit ? 'none' : '' }"
						slot="suffix" @click="selectClick">
					</i>
				</el-input> -->
				<!-- <el-button type="primary" @click="toCreate('add')" class="novel_list2">
                    <span class="el-icon-plus" style="font-weight: bold;"></span>
                    <span>创建新作品</span>
                </el-button> -->
				<!-- <div class="novel_list2 cursor_1 shrink-0 t-m-l-20" >

				</div>
				<div class="novel_list2 cursor_1 shrink-0 t-m-l-20" @click="toCreate">
					管理
				</div> -->
			</div>

		</div>
		<div class="novel_list3" v-if="!isNotEmpty">
			<noData></noData>
		</div>
		<div class="novel_list3" v-if="isNotEmpty" ref="scrollContainer">
			<!-- <div v-if="!isEdit" class="selectBtn">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                    @change="handleCheckAllChange">全选</el-checkbox>
                <el-button type="text" @click="batchDel" style="margin-left: 20px;">删除</el-button>
            </div> -->
			<div class="item">
				<el-checkbox-group v-model="checkedCities">
					<div class="novel_list4" v-for="(item, i) in novelList" :key="i" @click.stop="nextStep(i, 1)">
						<el-checkbox :label="item.id" v-if="!isEdit" class="no-label"></el-checkbox>
						<div style="position: relative;width: 100px;height: 133px;flex-shrink: 0;border-radius: 8px;">
							<img class="novel_list5" style="object-fit: cover;" :src="item.cover || require('@/assets/image/cover_default.jpg')" alt=""
								@click.stop="nextStep(i, 1)">
						</div>

						<div class="novel_list6">
							<div class="novel_list7" v-html="item.title && item.title.replace(/-->|->|--&gt;|#/g, '')">
							</div>
							<div class="novel_list8">{{ item.categorys }}</div>
							<div class="novel_list9" style="justify-content: flex-end;">
								<div class="novel_list10">{{ item.createTime }} <span class="t-m-l-20">{{
									$validata.formatNumberToUnit(item.words, 1) }}字</span></div>

								<!-- <div class="novel_list10"><span>最近更新时间：</span>{{ item.lastUpdate }}<span
                                        class="t-m-l-20 novel_time_text" v-if="item.lastUpdateTime">{{
                                            item.lastUpdateTime
                                        }}更新</span>
                                </div> -->
								<div class="novel_list11 noBorderArray">
									<!-- <div class="novel_list12 cursor_1 btn_item" v-for="(items, l) in scriptListIcon" :key="l"
                                        @click.stop="nextStep(i, l)"
                                        @mouseenter="() => { selectedIndex = l; selectedId = item.id }"
                                        @mouseleave="() => { selectedIndex = -1; selectedId = '' }">
                                        <img :src="items.icon" alt="">
                                        <span>{{ items.title }}</span>
                                    </div> -->
									<template v-for="(items, l) in hotHistoryList">
										<el-tooltip popper-class="novel_toolTip"
											:disabled="Object.hasOwn(items, 'title') ? false : true" :key="l"
											placement="top" effect="light" :content="items.title">
											<div class="novel_list12 cursor_1 btn_item" @click.stop="nextStep(i, l)"
												@mouseenter="() => { selectedIndex = l; selectedId = item.id }"
												@mouseleave="() => { selectedIndex = -1; selectedId = '' }">
												<img class="t-m-r-5" v-if="items.name == '置顶'"
													:src="selectedIndex === l && selectedId == item.id || item.top > 0 ? items.icon : items.uIcon"
													alt="">
												<img class="t-m-r-5" v-else
													:src="selectedIndex === l && selectedId == item.id ? items.icon : items.uIcon"
													alt="">
												<span v-if="items.name == '置顶'" :class="item.top > 0 ? 'sc' : ''">{{
													item.top > 0 ? '已置顶' : items.name
												}}</span>
												<span v-else>{{ items.name }}</span>
											</div>
										</el-tooltip>
									</template>
								</div>
							</div>
						</div>
					</div>
					<div ref="loader" class="loader">
						<div v-if="loading">加载中...</div>
						<!-- <div v-if="!hasMore">没有更多数据了</div> -->
					</div>
				</el-checkbox-group>
			</div>
		</div>

		<!-- <bottomPage v-show="total" :total="total" @currentNUm="currentNUm" :pageSize="this.pageSize" ref="bottompage">
        </bottomPage> -->
		<!-- <delPopup ref="delPopup" @confirm="confirmDel"></delPopup> -->
	</div>
</template>

<script>
import data from '@/assets/data';
import noData from '@/components/no_data.vue';
import delPopup from '@/components/del_popup.vue';
import HApi from '@/api/hottc'
import { EncryptionUtil } from '@/utils/encrypt'
import { scrollerMixin } from '@/mixin/scrollerMixin';
export default {
	mixins: [scrollerMixin],
	components: {
		noData, delPopup,
	},
	data() {
		return {
			hotHistoryList: data.hotHistoryList,//作品编辑
			delId: null, //删除id
			query: '',//搜索关键字
			status: '',// 空是全部，连载状态(0连载中 1已完结)
			length: '',//篇幅设定
			isEdit: true,//默认true不编辑，true编辑
			checkAll: false,
			checkedCount: 0,//选中状态
			checkedCities: [],
			isIndeterminate: false,
			novelList: [],
			searchResult: true,
			pageNum: 1,
			pageSize: 10,
			total: 0,
			uid: '',
			title: ''
		}
	},
	watch: {
		// 监听 list 变化，数据加载完成后初始化观察器
		novelList: {
			handler() {
				this.$nextTick().then(() => {
					this.initObserver({
						scrollRequest: () => {
							this.getList()
						}
					})
				})
			},
		}
	},
	mounted() {
		const { uid, title } = this.$route.query
		if (uid) {
			this.uid = uid
			this.title = title
			if (this.uid) {
				this.getList()
			}
		}

	},
	methods: {
		//获取分类列表
		async getList() {
			this.loading = true;
			try {
				const response = await HApi.subjectLog(this.uid, { pageNum: this.pageNum, pageSize: this.pageSize })
				if (response.code === 200) {
					this.novelList = [...this.novelList, ...response.data];
					this.pageNum++;
					this.hasMore = response.data.length >= this.pageSize;
					this.isNotEmpty = this.novelList.length > 0 ? true : false
				} else {
					this.$message.warning(response.msg)
				}

			} catch (error) {
				console.error('滚动分页出现问题:', error);
			} finally {
				this.loading = false;
			}
		},

		//0置顶，1删除
		nextStep(i, l) {
			//置顶
			if (l == 0) {
				if (this.novelList[i].top > 0) {

				} else {
					HApi.top(this.novelList[i].id).then(res => {
						if (res.code === 200) {
							this.$message.success('置顶成功！')
							this.pageNum = 1
							this.novelList = []
							this.getList()
						} else {
							this.$message.warning(res.msg)
						}
					})
				}

				return
			}
			//详情
			if (l == 1) {
				let params = {
					editType: 3,
					uid: this.uid,
					id: this.novelList[i].id
				}
				sessionStorage.setItem('rm_editItem', JSON.stringify(params))
				this.$router.push({ path: '/hottc_result', query: { uid: this.uid } })
				// HApi.subjectDetail(this.novelList[i].id).then(res => {
				// 	if (res.code === 200) {
				//         params.content = res.data.content
				// 		sessionStorage.setItem('rm_editItem', JSON.stringify(params))
				// 		this.$router.push({ path: '/hottc_result', query: { uid: this.uid } })
				// 	}else{
				// 		this.$message.warning(res.msg)
				// 	}
				// })
				return
			}
			//删除
			if (l == 2) {
				// this.$refs.delPopup.openPrompt(0)
				this.$confirm('删除后将无法恢复，请谨慎操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delId = i
					HApi.delLog(this.novelList[i].id).then((res) => {
						if (res.code == 200) {
							this.$message.success('删除成功！')
							this.novelList.splice(i, 1)
							this.isNotEmpty = this.novelList.length > 0 ? true : false
						} else {
							this.$message.warning(res.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				return
			}

		},

	}
}
</script>

<style lang="scss" scoped>
/*  */
.novel_input-with-select {
	width: 300px;
	background-color: #FFFFFF !important;

	::v-deep(.el-input__inner) {
		width: 100% !important;
		background-color: #FFFFFF !important;

		&::placeholder {
			color: #aaa;
		}
	}
}

.search_select {

	::v-deep(.el-input__inner) {
		width: 100% !important;
		background-color: #FFFFFF !important;

		&::placeholder {
			color: #aaa;
		}
	}
}

.novel_input-with-select .el-icon-search {
	font-size: 120% !important;
}

.novel_input-with-select>.el-input__inner {
	background-color: #FFFFFF !important;
	width: 300px !important;
}

#novel_list {
	width: 100%;
	// height: 100%;
	flex: 1;
	background-color: #FFFFFF;
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	margin: 16px 20px 0 20px;
}

.novel_list {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	height: 77px;
	justify-content: space-between;
	border-bottom: 1px solid #E6EBF0;
	padding: 0 25px;
	position: relative;
}

.novel_list1 {
	font-weight: bold;
	font-size: 19px;
	color: #111111;
	display: flex;
	align-items: center;
	flex-shrink: 0;
}

.novel_list1 img {
	width: 23px;
	height: 23px;
	margin-right: 5px;
}

.no-label {
	padding-right: 20px !important;

	::v-deep .el-checkbox__label {
		display: none !important;
	}
}



/* .novel_list2 {
	width: 110px;
	height: 21px;
	background: url('../assets/image/icon_list.png') no-repeat;
	background-size: 21px 21px;
	background-position: left center;
	padding-left: 25px;
	font-size: 17px;
	color: var(--tech-primary);
	line-height: 21px;
} */

.novel_list2 {
	height: 40px;

	span {
		font-size: 17px;
	}
}

/* .novel_list2:hover {
	background: url('../assets/image/icon_list1.png') no-repeat;
	background-size: 21px 21px;
	color: var(--tech-primary);
} */

.novel_list3 {
	flex: 1;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
}

.novel_list3 .selectBtn {
	flex-shrink: 0;
	height: 50px;
	line-height: 50px;
	padding: 0 25px;
}

.novel_list3 .item {
	flex: 1;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	@include scrollbar();
	&:hover{
		@include scrollbar_hover();
	}
}

.novel_list4 {
	display: flex;
	margin: 0 25px;
	padding: 21px 0;
	border-bottom: 1px solid #E6EBF0;
}

.novel_list5 {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 4px;
	flex-shrink: 0;
}

.length_text {
	position: absolute;
	display: block;
	font-size: 15px;
	text-align: center;
	top: 0;
	left: 0;
	width: 40px;
	/* 长方形的宽度 */
	height: 24px;
	/* 形状颜色 */
	border-top-left-radius: 6px;
	/* 左上角与父 div 圆角一致 */
	border-bottom-right-radius: 12px;
	/* 右侧弧度 */

	&.long {
		background: #FF6603;
		color: #fff;
	}

	&.duan {
		background: #00CF9B;
		color: #fff;
	}

	&.zhong {
		background: #548AFF;
		color: #fff;
	}
}

.novel_list6 {
	flex: 1;
	height: 133px;
	margin-left: 10px;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.novel_list7 {
	font-weight: bold;
	font-size: 18px;
	color: #111111;
}

.novel_list8 {
	padding: 0 10px;
	height: 36px;
	text-align: center;
	line-height: 36px;
	margin: 1.0625rem 0;
	background: #F8F8F8;
	border-radius: 4px;
	font-size: 16px;
	color: #666666;
	width: fit-content;
}

.novel_list9 {
	width: 100%;
	display: flex;
	justify-content: space-between !important;
}

.novel_time_text {
	color: var(--tech-primary);
}

.novel_list10 {
	font-size: 14px;
	color: #666666;
}

.novel_list11 {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	align-items: center;
	width: 300px;
}

.novel_list12 {
	display: flex;
	align-items: center;
	font-size: 15px;
	color: #333333;

	.sc {
		color: var(--tech-primary);
	}
}

.novel_list12:hover {
	color: var(--tech-primary);
}

.novel_list12 img {
	width: 16px;
	height: 16px;
	margin-right: 5px;
}

.tops {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 20px;
	font-weight: bold;
}
</style>